import { CheckIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react'

import { ArrowSvg } from '@/views/assets/ArrowSvg'
import { MicrophoneIcon } from '@/views/assets/MicrophoneIcon'

import { useAudioRecorder } from '../../../context/AudioRecorderContext/AudioRecorderContext'

import { AudioWave } from './AudioWave'

const StopIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="currentColor"
  >
    <rect width="10" height="10" rx="1" />
  </svg>
)

export const RecordingInProgressButton = () => {
  const {
    audioContext,
    visStream,
    stopRecordingAndUpload,
    availableDevices,
    selectedDeviceId,
    switchMicrophone,
  } = useAudioRecorder()

  const selectedDevice = availableDevices.find(
    (d) => d.deviceId === selectedDeviceId,
  )
  const deviceLabel = selectedDevice?.label || 'Microphone'

  return (
    <Flex gap={2} alignItems="center" width="fit-content">
      <IconButton
        aria-label="Stop recording"
        onClick={stopRecordingAndUpload}
        variant="brand-solid-white"
        color="red.500"
        size="md"
        isRound
        icon={<StopIcon />}
      />
      <Menu>
        <MenuButton
          as={Button}
          variant="brand-solid-white"
          position="relative"
          overflow="hidden"
          w="250px"
          flexShrink={0}
          _hover={{ bg: 'white' }}
          _active={{ bg: 'white' }}
          sx={{
            '& > span': {
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            },
            '&:hover .hover-overlay, &[aria-expanded="true"] .hover-overlay': {
              opacity: 1,
            },
          }}
        >
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={0}
            pointerEvents="none"
          >
            <AudioWave
              className="w-full h-full"
              audioContext={audioContext}
              visStream={visStream}
            />
          </Box>
          <Box
            className="hover-overlay"
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={1}
            bg="#E6E6E6"
            opacity={0}
            transition="opacity 0.15s"
            pointerEvents="none"
          />
          <Flex
            alignItems="center"
            gap={2}
            zIndex={10}
            position="relative"
            width="100%"
            justifyContent="space-between"
          >
            <Flex alignItems="center" gap={2} flex={1} minW={0}>
              <MicrophoneIcon boxSize={4} flexShrink={0} />
              <Text isTruncated title={deviceLabel}>
                {deviceLabel}
              </Text>
            </Flex>
            <ArrowSvg flexShrink={0} />
          </Flex>
        </MenuButton>
        <MenuList rounded="1.25rem" bg="white" overflow="hidden">
          {availableDevices.map((device) => (
            <MenuItem
              key={device.deviceId}
              onClick={() => switchMicrophone(device.deviceId)}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              bg="white"
              py={2.5}
              px={5}
              _hover={{ bg: '#f6f6f6' }}
            >
              <Box isTruncated maxW="250px" title={device.label}>
                {device.label}
              </Box>
              {device.deviceId === selectedDeviceId && <CheckIcon ml={2} />}
            </MenuItem>
          ))}
          {availableDevices.length === 0 && (
            <MenuItem isDisabled bg="white" py={2.5} px={5}>
              No microphones available
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    </Flex>
  )
}
